import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Axios from "Services/Auth/AxiosInterceptors";

const fetchAccessLevels = async (page, search = "", accessLevel = "INDIVIDUAL", perPage = 20) => {
  const params = { page, perPage };
  if (search) params.search = search;
  if (accessLevel) params.accessLevel = accessLevel;
  const response = await Axios.get(`/doctor-access/doctor/access-levels/listing`, {
    params,
  });
  return response.data;
};

export const useAccessLevels = (initialPage = 1, search = "", accessLevel = "INDIVIDUAL") => {
  const [page, setPage] = useState(initialPage);

  const { data, isLoading, isError, refetch } = useQuery(
    ["accessLevels", page, search, accessLevel],
    () => fetchAccessLevels(page, search, accessLevel),
    {
      keepPreviousData: true,
    }
  );

  const pagination = data?.result?.pagination;

  const goToNextPage = useCallback(() => {
    if (pagination?.hasNext) {
      setPage((prev) => prev + 1);
    }
  }, [pagination?.hasNext]);

  const goToPreviousPage = useCallback(() => {
    if (pagination?.hasPrevious) {
      setPage((prev) => Math.max(prev - 1, 1));
    }
  }, [pagination?.hasPrevious]);

  const setPageNumber = useCallback(
    (pageNumber) => {
      if (!pagination) {
        setPage(pageNumber);
        return;
      }

      const maxPage = pagination?.next ? pagination.next - 1 : pageNumber;
      const validPage = Math.min(Math.max(pageNumber, 1), maxPage);

      setPage(validPage);
    },
    [pagination]
  );

  return {
    data,
    isLoading,
    isError,
    page,
    hasNext: pagination?.hasNext ?? false,
    hasPrevious: pagination?.hasPrevious ?? false,
    goToNextPage,
    goToPreviousPage,
    setPageNumber,
    refetch,
  };
};
